import { Button, EmptyState } from '@neshane/blueberry';

import styles from './PageEmptyState.module.css';

export const PageEmptyState = ({
    illustration,
    iconName,
    iconVariant,
    title,
    description,
    buttonLabel,
    onClick,
    isDisabled = false,
}) => {
    const illustrationNode =
        typeof illustration === 'string' ? (
            <img alt="" src={illustration} className={styles.illustration} />
        ) : (
            illustration
        );

    const actions =
        buttonLabel && onClick
            ? [
                  <Button
                      key="action"
                      variant="primaryBrand"
                      text={buttonLabel}
                      isDisabled={isDisabled}
                      onClick={onClick}
                  />,
              ]
            : undefined;

    const illustrationProps = illustration
        ? { illustration: illustrationNode }
        : { iconName, iconVariant };

    return (
        <div className={styles.container}>
            <EmptyState
                {...illustrationProps}
                title={title}
                subtitle={description}
                actions={actions}
                className="py-16"
            />
        </div>
    );
};